import {
  HomeIcon,
  ShoppingCartIcon,
  KeyboardReturnIcon,
  ScaleIcon,
  WifiProtectedSetupIcon,
  CreditCardIcon,
  CardMembershipIcon,
  BuildIcon,
  AssessmentIcon,
  AccountBoxIcon,
  SettingsIcon,
  HelpCenterIcon,
  HandymanIcon,
} from "../common/iconsData";

interface InsideType {
  name: string;
  path: string;
}

interface SiderBarMenusType {
  name: string;
  icon: JSX.Element;
  path: string;
  inside: InsideType[];
}

// menu and submenu are dynamic only icons are taking from here
export const sideBarMenus: SiderBarMenusType[] = [
  {
    name: "Home",
    icon: <HomeIcon />,
    path: "dashboard",
    inside: [],
  },
  {
    name: "BookShipment",
    icon: <CardMembershipIcon />,
    path: "book_shipment",
    inside: [],
  },
  {
    name: "Order",
    icon: <ShoppingCartIcon />,
    path: "order",
    inside: [],
  },
  {
    name: "Returns",
    icon: <KeyboardReturnIcon />,
    path: "returns",
    inside: [],
  },
  {
    name: "Weight Management",
    icon: <ScaleIcon />,
    path: "weight-and-managements",
    inside: [
      {
        name: "Weight Discrepancies",
        path: "weight-and-discrepancies",
      },
    ],
  },
  {
    name: "Set up",
    icon: <WifiProtectedSetupIcon />,
    path: "set-up-and-management",
    inside: [
      {
        name: "Service",
        path: "all_service",
      },
      {
        name: "Shipment Profiles",
        path: "shipment_profiles",
      },
      {
        name: "Customer",
        path: "customer_search",
      },
    ],
  },
  {
    name: "Tools",
    icon: <HandymanIcon />,
    path: "tools",
    inside: [
      {
        name: "Rate Calculator",
        path: "rate-calculator",
      },
      {
        name: "Reports",
        path: "reports",
      },
      {
        name: "Bulk Action",
        path: "bulk-action",
      },
      {
        name: "MIS Report",
        path: "mis-report",
      },
    ],
  },
  {
    name: "Billing",
    icon: <CreditCardIcon />,
    path: "billing",
    inside: [],
  },
  {
    name: "Settings",
    icon: <SettingsIcon />,
    path: "settings",
    inside: [],
  },
  {
    name: "Support & Help",
    icon: <HelpCenterIcon />,
    path: "support-and-help",
    inside: [],
  },
];

const normalizeMenuKey = (value: string | undefined) =>
  value?.toLowerCase().replace(/[\s_-]/g, "") ?? "";

export const getSideBarMenuIcon = (
  path: string | undefined,
  name?: string
): JSX.Element | undefined => {
  if (!path && !name) return undefined;

  const byPath = sideBarMenus.find((item) => item.path === path);
  if (byPath) return byPath.icon;

  const normalizedName = normalizeMenuKey(name);
  return sideBarMenus.find(
    (item) => normalizeMenuKey(item.name) === normalizedName
  )?.icon;
};

  // {
  // name: "Tools",
  // icon: <BuildIcon  />,
  // path: "tools",
  // inside: [
  // {
  //   name: "Shipping",
  //   path: "shipping",
  // },

  //   {
  //     name: "Rate Card",
  //     path: "rate-card",
  //   },
  //   {
  //     name: "Shipping Rates Calculator",
  //     path: "shipping-rates-calculator",
  //   },
  //   {
  //     name: "Bulk Actions",
  //     path: "bulk-actions",
  //   },
  // ],
  // },
  // {
  //   name: "Report",
  //   icon: <AssessmentIcon  />,
  //   path: "report",
  //   inside: [],
  // },
  // {
  //   name: "Buyer Experience",
  //   icon: <AccountBoxIcon  />,
  //   path: "buyer-and-experience",
  //   inside: [],
  // },
  // {
  //   name: "Delivery Boost",
  //   icon: <CardMembershipIcon  />,
  //   path: "delivery-and-boost",
  //   inside: [],
  // },

  // {
  //   name: "Support & Help",
  //   icon: <HelpCenterIcon  />,
  //   path: "support-and-help",
  //   inside: [],
  // },

interface OrdersTabType {
  label: string;
  filter: string;
}

export const ordersForwardTab: OrdersTabType[] = [
  {
    label: "Ready to ship",
    filter: "ready_to_ship",
  },
  {
    label: "Booked",
    filter: "booked",
  },
  {
    label: "Scheduled Pickup",
    filter: "pickup_raised",
  },
  {
    label: "Picked Up",
    filter: "picked_up",
  },
  {
    label: "Not Picked",
    filter: "not_picked",
  },
  {
    label: "In Transit",
    filter: "in_transit",
  },
  {
    label: "Exception",
    filter: "exception",
  },
  {
    label: "Out For Delivery",
    filter: "out for delivery",
  },
  {
    label: "Cancelled",
    filter: "cancelled",
  },
  {
    label: "Delivered",
    filter: "delivered",
  },
  {
    label: "All",
    filter: "",
  },
];

// Sent as `status` with shipment=rto; the backend only accepts these return_* values for RTO
// (it has no RTO "exception" status).
export const ordersRtoTab: OrdersTabType[] = [
  {
    label: "Initiated",
    filter: "return_initiated",
  },
  {
    label: "In Transit",
    filter: "return_in_transit",
  },
  {
    label: "Out For Delivery",
    filter: "return_out_for_delivery",
  },
  {
    label: "Delivered",
    filter: "return_delivered",
  },
  {
    label: "All",
    filter: "",
  },
];

export const returnsTab = [
  // {
  //   label: "Ready To Ship",
  //   filter: "ready_to_ship",
  // },
  // {
  //   label: "Pickup Raised",
  //   filter: "pickup_raised",
  // },
  // {
  //   label: "Booked",
  //   filter: "booked",
  // },
  // {
  //   label: "Cancelled",
  //   filter: "cancelled",
  // },
  // {
  //   label: "Delivered",
  //   filter: "delivered",
  // },
  // {
  //   label: "In Transit",
  //   filter: "in_transit",
  // },
  // {
  //   label: "Exception",
  //   filter: "exception",
  // },
  // {
  //   label: "Out for Delivery",
  //   filter: "out_for_delivery",
  // },
  // {
  //   label: "Not Picked",
  //   filter: "not_picked",
  // },
  // {
  //   label: "Picked Up",
  //   filter: "picked_up",
  // },
  {
    label: "Ready to ship",
    filter: "ready_to_ship",
  },
  {
    label: "Booked",
    filter: "booked",
  },
  {
    label: "Scheduled Pickup",
    filter: "pickup_raised",
  },
  {
    label: "Picked Up",
    filter: "picked_up",
  },
  {
    label: "Not Picked",
    filter: "not_picked",
  },
  {
    label: "In Transit",
    filter: "in_transit",
  },
  {
    label: "Exception",
    filter: "exception",
  },
  {
    label: "Out For Delivery",
    filter: "out for delivery",
  },
  {
    label: "Cancelled",
    filter: "cancelled",
  },
  {
    label: "Delivered",
    filter: "delivered",
  },
  {
    label: "All",
    filter: "",
  },
];
